import { render, staticRenderFns } from "./TypeProperty.vue?vue&type=template&id=6e9971c7&scoped=true"
import script from "./TypeProperty.vue?vue&type=script&lang=js"
export * from "./TypeProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9971c7",
  null
  
)

export default component.exports